export default {
  H5Support: {
    noticeConfig: {
      getList: 'api/noticeConfig/getNoticeList',
      add: 'api/noticeConfig/addNotice',
      update: 'api/noticeConfig/updateNotice',
      del: 'api/noticeConfig/del'
    }
  }
}
